export default __webpack_public_path__ + "static/media/Anand.2cd384ce.jpeg";